/* eslint-disable @stylistic/line-comment-position */
/* eslint-disable no-inline-comments */

import HeroDropdown from 'views/components/heroButton/heroDropdown/HeroDropdown';

export function courseHasCalculator(courseId) {
    const coursesWithoutCalculator = [
        1, // Geschiedenis
        4, // Duits
        7, // Nederlands
        9, // Studiebegeleiding
        10, // Engels
        11, // Spaans
        18, // Frans
        38, // Loopbaanoriëntatie en -begeleiding
        40, // Latijn
        60, // Grieks
        62, // Lichamelijke Opvoeding
        70, // Studievaardigheden
        74, // Levensbeschouwing
        75, // Maatschappijleer
        80, // Godsdienst
        116, // Beeldende vorming
        120, // Filosofie
        125, // Mediawijsheid
        128, // Culturele en Kunstzinnige Vorming
        149, // Maatschappijwetenschappen
        153, // Burgerschap
        165, // Maatschappijkunde
        170, // Mentoraat
        182, // Literatuur
        220, // Tekenen
    ]

    return !coursesWithoutCalculator.includes(courseId)
}

export function calculatorToggleSettings(model) {
    return {
        label: window.i18n.gettext('Show calculator'),
        icon: 'calculator',
        hasToggle: true,
        toggleState: parseInt(model.getMetadata('show_calculator')),
    }
}

export const defaultCalculatorUIState = {
    show: false,
}

export function renderCalculator(
    calculatorUIState,
    activityModel,
) {
    if (parseInt(activityModel.getMetadata('show_calculator'))) {
        calculatorUIState.show = true
    }

    if (
        ACL.checkRole(ACL.roles.TEACHER) &&
        courseHasCalculator(activityModel.getGroupModel()?.get('course_id'))
    ) {
        Backbone.View.header.addButton(
            new HeroDropdown({
                firstLine: window.i18n.gettext('Options'),
                icon: 'arrow-drop-down-circle',
                dropdownItems: [{
                    ...calculatorToggleSettings(activityModel),
                    callback: (state) => {
                        activityModel.setMetadata('show_calculator', state)
                        calculatorUIState.show = !calculatorUIState.show
                    },
                }]
            })
        )
    }
}
